// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"560":"d4e803e0","572":"33f9a5dd","634":"d8c97d00","777":"13b0a9f0","833":"13b0a9f0"}[chunkId] + ".chunk.css";
};